export const DashboardSquareSelectedIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M12 3.75C12 3.05109 12 2.70164 12.1142 2.42597C12.2664 2.05844 12.5585 1.76642 12.926 1.61418C13.2017 1.5 13.5511 1.5 14.25 1.5C14.9489 1.5 15.2983 1.5 15.574 1.61418C15.9416 1.76642 16.2336 2.05844 16.3858 2.42597C16.5 2.70164 16.5 3.05109 16.5 3.75V6.75C16.5 7.44891 16.5 7.79835 16.3858 8.07405C16.2336 8.44155 15.9416 8.7336 15.574 8.88585C15.2983 9 14.9489 9 14.25 9C13.5511 9 13.2017 9 12.926 8.88585C12.5585 8.7336 12.2664 8.44155 12.1142 8.07405C12 7.79835 12 7.44891 12 6.75V3.75Z"
        fill="#1453F5"
      />
      <path
        opacity="0.4"
        d="M1.5 12C1.5 10.5858 1.5 9.8787 1.93934 9.43935C2.37868 9 3.08579 9 4.5 9H6C7.41422 9 8.1213 9 8.56065 9.43935C9 9.8787 9 10.5858 9 12V13.5C9 14.9142 9 15.6213 8.56065 16.0606C8.1213 16.5 7.41422 16.5 6 16.5H4.5C3.08579 16.5 2.37868 16.5 1.93934 16.0606C1.5 15.6213 1.5 14.9142 1.5 13.5V12Z"
        fill="#1453F5"
      />
      <path
        d="M12 3.75C12 3.05109 12 2.70164 12.1142 2.42597C12.2664 2.05844 12.5585 1.76642 12.926 1.61418C13.2017 1.5 13.5511 1.5 14.25 1.5C14.9489 1.5 15.2983 1.5 15.574 1.61418C15.9415 1.76642 16.2336 2.05844 16.3858 2.42597C16.5 2.70164 16.5 3.05109 16.5 3.75V6.75C16.5 7.44891 16.5 7.79835 16.3858 8.07405C16.2336 8.44155 15.9415 8.7336 15.574 8.88585C15.2983 9 14.9489 9 14.25 9C13.5511 9 13.2017 9 12.926 8.88585C12.5585 8.7336 12.2664 8.44155 12.1142 8.07405C12 7.79835 12 7.44891 12 6.75V3.75Z"
        stroke="#1453F5"
        strokeWidth="1.25"
      />
      <path
        d="M12 14.25C12 13.5511 12 13.2017 12.1142 12.926C12.2664 12.5585 12.5585 12.2664 12.926 12.1142C13.2017 12 13.5511 12 14.25 12C14.9489 12 15.2983 12 15.574 12.1142C15.9415 12.2664 16.2336 12.5585 16.3858 12.926C16.5 13.2017 16.5 13.5511 16.5 14.25C16.5 14.9489 16.5 15.2983 16.3858 15.574C16.2336 15.9415 15.9415 16.2336 15.574 16.3858C15.2983 16.5 14.9489 16.5 14.25 16.5C13.5511 16.5 13.2017 16.5 12.926 16.3858C12.5585 16.2336 12.2664 15.9415 12.1142 15.574C12 15.2983 12 14.9489 12 14.25Z"
        stroke="#1453F5"
        strokeWidth="1.25"
      />
      <path
        d="M1.5 12C1.5 10.5858 1.5 9.8787 1.93934 9.43935C2.37868 9 3.08579 9 4.5 9H6C7.41421 9 8.1213 9 8.56065 9.43935C9 9.8787 9 10.5858 9 12V13.5C9 14.9142 9 15.6213 8.56065 16.0606C8.1213 16.5 7.41421 16.5 6 16.5H4.5C3.08579 16.5 2.37868 16.5 1.93934 16.0606C1.5 15.6213 1.5 14.9142 1.5 13.5V12Z"
        stroke="#1453F5"
        strokeWidth="1.25"
      />
      <path
        d="M1.5 3.75C1.5 3.05109 1.5 2.70164 1.61418 2.42597C1.76642 2.05844 2.05844 1.76642 2.42597 1.61418C2.70164 1.5 3.05109 1.5 3.75 1.5H6.75C7.44891 1.5 7.79835 1.5 8.07405 1.61418C8.44155 1.76642 8.7336 2.05844 8.88585 2.42597C9 2.70164 9 3.05109 9 3.75C9 4.44891 9 4.79836 8.88585 5.07403C8.7336 5.44156 8.44155 5.73358 8.07405 5.88582C7.79835 6 7.44891 6 6.75 6H3.75C3.05109 6 2.70164 6 2.42597 5.88582C2.05844 5.73358 1.76642 5.44156 1.61418 5.07403C1.5 4.79836 1.5 4.44891 1.5 3.75Z"
        stroke="#1453F5"
        strokeWidth="1.25"
      />
    </svg>
  );
};
